class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    if(document.querySelector('button.search-modal__close-button')){
      document.querySelector('button.search-modal__close-button').addEventListener('click', this.close.bind(this));
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  // onBodyClick(event) {
  //   if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  // }

  open(event) {
    // this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    console.log('event.target');
    console.log(event.target);
    if(event.target.closest('summary').getAttribute('data-search-summary-id')){
      document.getElementById(event.target.closest('summary').getAttribute('data-search-summary-id')).classList.add('active')
    }
    let a = this.detailsContainer.querySelector('[tabindex="-1"]') ? this.detailsContainer.querySelector('[tabindex="-1"]') : ''
    let b = this.detailsContainer.querySelector('input:not([type="hidden"])') ? this.detailsContainer.querySelector('input:not([type="hidden"])') : ''
    // if(this.summaryToggle.getAttribute('data-search-summary-id')){
    //   a = document.getElementById(this.summaryToggle.getAttribute('data-search-summary-id')).querySelector('[tabindex="-1"]')
    //   b = document.getElementById(this.summaryToggle.getAttribute('data-search-summary-id')).querySelector('input:not([type="hidden"])')
    // }

    if(a && b) trapFocus(a,b);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
      if(this.detailsContainer.querySelector('summary').getAttribute('data-search-summary-id')){
      document.getElementById(this.detailsContainer.querySelector('summary').getAttribute('data-search-summary-id')).classList.remove('active')
    }
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
